
export default [
    {
        path: '/manage/companyRecode',
        component: resolve => require(['../page.vue'], resolve),
        meta: {
            title: '离职记录',
            keepAlive: false
        }
    },
];
  